class GerarPDF {
  constructor(loading) {
    this.loading = loading;
    this.events();
  }

  events() {
    if (document.getElementById("gerar-pdf")) {
      let gerar_pdf = document.getElementById("gerar-pdf");
      gerar_pdf.addEventListener("click", this.gerarCV.bind(this));
    }
  }

  gerarCV() {

    let data = {};

    if(jQuery('#gerar-pdf').data("candidato")){
        data.candidato_id = jQuery('#gerar-pdf').data("candidato")
    }
    
    this.loading.showLoadingAnimation();
    jQuery.ajax({
      url: maisempregoData.root_url + "/wp-json/maisemprego/candidato/v1/cv",
      type: "POST",
      dataType: "json",
      data: data,
      beforeSend: function (xhr) {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },

      success:(response) =>{

        this.loading.hideLoadingAnimation();
        let link = document.createElement('a');
        link.href = maisempregoData.root_url+'/wp-content/uploads/cv/'+ response.data.filename;
        link.target="_blank"
        link.click();

        return

        // use this code when I print using js
          console.log(response) 
          
          var printWindow = window.open('', '_blank');
          printWindow.document.open();
          printWindow.document.write('<html><head><style>'+response.data.css+'+</style></head><body>');
          printWindow.document.write('<style>@page { margin: 0; }</style>'); // Set margin to zero
          printWindow.document.write('<style>@page { size: auto; }</style>'); // Adjust page size
          printWindow.document.write('<style>@page { margin-top: 0; margin-bottom: 0; }</style>'); // Hide header and footer
          printWindow.document.write(response.data.content);
          printWindow.document.write('</body></html>');
          printWindow.document.close();
          printWindow.print();
      },
      error: function (response) {
        console.log(response);
        console.log("AJAX request failed");
      },
    });

    // jQuery.ajax({
    //     url:  maisempregoData.root_url + "/wp-json/maisemprego/candidato/v1/cv",  // Replace with your AJAX endpoint URL
    //     method: 'POST',
    //     data: {

    //      },  // Replace with your AJAX action name and additional data if needed
    //      beforeSend: function (xhr) {
    //         xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
    //      },
    //     success: function(response) {

    //         console.log(response);

    //     }
    // });
  }
}

export default GerarPDF;
